import clsx from "clsx";
import { FC, useState, useEffect } from "react";
import { IPermission } from "../../views/shared/settings/RolesAndPermisions/RoleList";

export const CheckBoxInputV2 = ({scope, label, id, name, onChange, value, checked, error, helperText, classes,disabled, staffPerms}: ICheckBoxInput): JSX.Element => {
  // Check if this permission exists in staffPerms based on description matching label
  const hasMatchingPermission = staffPerms?.some((perm: IPermission) => perm.description === label);
  
  // Use the matching permission status or the passed checked value
  const isChecked = hasMatchingPermission || checked;
  const [checkedValue, setCheckedValue] = useState<boolean>(isChecked);
  

  // Update checked state when staffPerms or checked prop changes
  useEffect(() => {
    const shouldBeChecked = hasMatchingPermission || checked;
    setCheckedValue(shouldBeChecked);
  }, [hasMatchingPermission, checked]);



  // const staffPermskk = staffPerms?.filter((perm:IPermission) => checkedValue && perm.description !== label)
  // console.log("staffPermsFormChaeck", staffPermskk)

  return (
    <div className="space-x-6">
      <label className={clsx("inline-flex items-center cursor-pointer")}>
        <input
          type="checkbox"
          className={clsx(
            `cursor-pointer border border-primary-main dark:border-transparent  checked:outline-white focus:outline-white outline-none active:outline-white dark:outline-darkBg text-primary-main`, 
            classes
          )}
          name={name}
          id={id}
          value={value}
          checked={checkedValue}
          onChange={() => {
            const newCheckedValue = !checkedValue;
            setCheckedValue(newCheckedValue);
            // Pass both the scope and the checked status to parent
            onChange?.({ scope, checked: newCheckedValue, label });
          }}
          disabled={disabled}
        />
        <span className="ml-2 text-sm font-medium text-gray-900 dark:text-darkBg-mainText">{label}</span>
      </label>
      <div className={clsx("text-xs text-gray-400", { ["text-danger-main"]: error })}>{helperText}</div>
    </div>
  );
};

interface ICheckBoxInput {
  scope: string;
  label: string;
  id?: string;
  name: string;
  value?: string;
  selectedValue?: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: (data: { scope: string; checked: boolean; label: string }) => void;
  error?: string;
  helperText?: string;
  classes?: string;
  staffPerms?: IPermission[];
}
